import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM12 17.969C11.448 17.969 11 17.521 11 16.969C11 16.417 11.448 15.969 12 15.969C12.552 15.969 13 16.417 13 16.969C13 17.521 12.552 17.969 12 17.969ZM13 14C13 14.553 12.552 15 12 15C11.448 15 11 14.553 11 14V7C11 6.448 11.448 6 12 6C12.552 6 13 6.448 13 7V14Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'ExclamationMarkFill');

export default Icon;
